"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OuterLogo = require("Assets/Images/outer_logo.png");
var InnerLogo = require("Assets/Images/inner_logo.png");
require("../Styles/CustomSpinner.css");
var Center_1 = require("./Center");
exports.CustomSpinner = function () {
    return (React.createElement(Center_1.Center, { horizontal: true, vertical: true },
        React.createElement("div", { className: "spinner-container" },
            React.createElement("img", { src: OuterLogo, className: "spinner-outer" }),
            React.createElement("img", { src: InnerLogo, className: "spinner-inner" }))));
};
//# sourceMappingURL=CustomSpinner.js.map